import PhoneInput from 'react-phone-input-2';
import styled from 'styled-components';
import { useEffect } from 'react';

import 'react-phone-input-2/lib/style.css';

// Define styled wrapper for the phone input
const StyledPhoneInputWrapper = styled.div<{ error?: boolean }>`
    .react-tel-input {
        width: 100%;
    }

    .react-tel-input .selected-flag {
        border-top: 1px solid hsla(220, 20%, 80%, 0.4);
        border-left: 1px solid hsla(220, 20%, 80%, 0.4);
        border-bottom: 1px solid hsla(220, 20%, 80%, 0.4);
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        max-height: 2.5rem;

        &:hover {
            border-color: hsl(220, 20%, 65%);
        }
    }

    .react-tel-input .flag-dropdown.open .selected-flag {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .react-tel-input .form-control {
        width: 100%;
        height: 40px;
        border-radius: 10px;
        border: 1px solid ${({ error }) => (error ? 'red' : 'hsla(220, 20%, 80%, 0.4)')};
        padding-left: 48px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 56, 63, 1);
        transition: border 120ms ease-in, background-color 120ms ease-in;

        &:hover {
            border-color: ${({ error }) => (error ? 'red' : 'hsl(220, 20%, 65%)')}; /* Gray hover color */
        }

        &:focus {
            outline:  ${({ error }) => (error ? '3px solid rgba(255, 0, 0, 0.5)' : '3px solid rgba(2, 70, 242, 0.5)')};
            border-color: ${({ error }) => (error ? 'red' : 'hsl(223, 98%, 48%)')};
        }
    }

    .react-tel-input .flag-dropdown {
        border: none;
        background: none;
    }

    .react-tel-input .country-list {
        border-radius: 10px;
        overflow: auto;
        // box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }
`;

interface PhoneInputProps {
    value: string;
    onChange: (e: string) => void;
    error?: boolean;
    errorText?: string;
    placeholder?: string;
}

const PhoneInputComponent = ({
    value,
    onChange,
    error,
    errorText,
    placeholder
}: PhoneInputProps) => {
    useEffect(() => {
        if (!value) {
            return;
        }
        const cleaned = value.replace(/\D/gu, '');

        if (!value.startsWith('+') && cleaned.length === 10) {
            onChange(`+1${cleaned}`);
        }
    }, []);

    return (
        <StyledPhoneInputWrapper error={error}>
            <PhoneInput
                country={'us'}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                buttonStyle={{
                    background: 'none',
                    border: error ? 'red' : 'none'
                }}
            />
            {error && errorText && <p style={{ color: 'red', fontSize: '12px' }}>{errorText}</p>}
        </StyledPhoneInputWrapper>
    );
};

export default PhoneInputComponent;
